import { Component, OnDestroy, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';

import { FormInputDateComponent } from '../../../../../../shared/modules/configurable-form/components/form-input-date/form-input-date.component';
import { Subject } from 'rxjs';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';

@Component({
  selector: 'form-input-date-disabled-dates',
  styleUrls: ['./form-input-date-disabled-dates.component.scss'],
  templateUrl: './form-input-date-disabled-dates.component.html',
})
export class FormInputDateDisabledDatesComponent extends FormInputDateComponent implements OnDestroy {
  public _destroyed$ = new Subject();

  constructor(translateService: TranslateService, store: Store<OrderBuilderState>, injector: Injector) {
    super(translateService, store, injector);
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
